import { generate } from "../../../core/js/utils/componentUtils";
import localStorage from '../../../core/js/utils/cacheUtils';
import { BACK_TO_CATALOG_DATA_KEY } from '../../../core/js/constants';
import template from 'back-to-catalog.j2';

function afterRender() {
    localStorage.remove(BACK_TO_CATALOG_DATA_KEY);
}

export function init(store, overrides = {}) {
    const config = {
        templateLocation: '.dom-back-to-catalog',
        template: template,
        watch: ['product.backToCatalogData'],
        afterRender: afterRender,
        name: 'backToCatalogComponent'
    };

    return generate(config, store, overrides);
}
